<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
    <div class="main">
      <el-form :model="pg" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div class="row">
          <el-form-item label="顺序号" prop="pgseq" verify int :gt="0">
            <el-input v-model="pg.pgseq" :maxlength="6" :disabled="disable"></el-input>
          </el-form-item>

          <el-form-item label="类型" prop="pgflg" verify>
            <el-select v-model="pg.pgflg" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in pgflgList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="评分项目" prop="pgname" verify>
            <el-input v-model="pg.pgname" :maxlength="60" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
        <div class="input-append">
          <el-form-item label="百分比" prop="pgratio" verify int :gt="0" :lte="leg_pgratio">
            <el-input v-model="pg.pgratio" :maxlength="5" :disabled="disable">
              <template slot="append">(已分配权重{{pgratiototal}})</template>
            </el-input>
          </el-form-item>
        </div>
        </div>
        <div class="content">
          <el-form-item label="备注">
            <el-input v-model="pg.pgremark" :maxlength="255" show-word-limit type="textarea" :disabled="disable"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <vggrid v-if="pg.project.projectdoneflg === '3' && pg.pgflg === '2'" ref="xGrid" :list="list" tableheight="400" flexname=""
            :cols="cols" :showfooter="false" :showPage="false" :resizable="true"
            :needBlackRow="false" :needPopMenu="true" :canbeEdit="true">
    </vggrid>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import common from '@/mixin/common'
  import vggrid from '../common/vggrid'

  export default {
    name: "pgForm",
    mixins: [common],
    data () {
      return {
        pg: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        pgflgList: [],
        list: [],
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80},
          {field: 'pgitemseq', fieldtype: 'I', title: '顺序号', calculExpr: '', width: 80},
          {field: 'pgitemname', fieldtype: 'C', title: '评分细则', calculExpr: '', editRender: {name: 'input'}},
          {field: 'pgitemss', fieldtype: 'F', title: '分值', calculExpr: '', editRender: {name: 'input'}}
        ]
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getPgflg()
      this.getPgItemList()
    },
    watch: {},
    filters: {},
    components: {vggrid},
    computed: {
      pgratiototal () {
        return Number(this.pg.pgratiototal ? this.pg.pgratiototal:0) + Number(this.pg.pgratio ? this.pg.pgratio : 0)
      },
      leg_pgratio () {
        return 100 - Number(this.pg.pgratiototal? this.pg.pgratiototal : 0)
      }
    },
    methods: {
      async init () {
        this.pg = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.list = []
      },
      async getPgflg () {
        this.pgflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'pgflg'}
        })
      },
      async getPgItemList () {
        // console.log(this.pg.project.projectdoneflg === '3' && this.pg.pgid !== 0)
        if (this.pg.project.projectdoneflg === '3' && this.pg.pgid !== 0) {
          this.list = await request({
            url: '/xmgl/project/getPgItemList',
            method: "get",
            params: {pgid: this.pg.pgid}
          })
          console.log(this.list)
        }
      },
      async addOrEdit () {
        this.submitForm('ruleForm').then(async() => {
          if (this.pg.project.projectdoneflg === '3') {
            this.pg.pgitems = this.$refs.xGrid.$refs.xGrid.getRecordset()
          } else {
            this.pg.pgitems = []
          }
          let data = await request({
            url: '/xmgl/project/savePg',
            method: "post",
            data: this.pg
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pgIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 520px;
    }



  }
</style>
